import * as React from "react";
import {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";



library.add(faTimes);
export class Header extends React.Component<HeaderProps, HeaderState> {
    static defaultProps: Partial<HeaderProps> = {
        Title:'',
        Icon:null
    };

    constructor(props: HeaderProps) {
        super(props);
        this.state = {};

    }

    public render() {
        return (
            <div className={'rnHeader'} style={{position:'relative'}}>
                <div style={{display:'flex',alignItems:'center'}}>
                    <span style={{fontSize:20}}>{this.props.Icon}</span>
                    <h2 style={{marginLeft:5,marginTop:0,marginRight:this.props.Icon!=null?3:0,marginBottom:0}}>
                        {this.props.Title}
                    </h2>
                </div>
                <div className={'rnCloseIcon'} onClick={()=>ReactUtilities.ExecuteMethodPropIfDefined(this.props.onClick)}>
                    <FontAwesomeIcon style={{fontSize:18}}  icon={'times'}/>
                </div>
            </div>
        )
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface HeaderProps {
    Title?:string;
    Icon?:JSX.Element;
    onClick:()=>void;


}

interface HeaderState {

}

//#endregion "My Region"